import { Input } from '@hover/blueprint';
import React from 'react';

import { MIME_TYPES } from 'src/shared/utils/photoMimeTypes';

interface UploadInputProps {
  onUploadPhotoChange: (event: React.FormEvent<HTMLInputElement>) => void;
  onInputDropOrClick?: (event: React.DragEvent<HTMLInputElement>) => void;
  setInvalidUpload: (invalidUpload: string | false) => void;
  setIsDragging: (isDragging: boolean) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

const UploadInput = ({
  onUploadPhotoChange,
  onInputDropOrClick,
  setInvalidUpload,
  setIsDragging,
  inputRef,
}: UploadInputProps) => (
  <Input
    accept={MIME_TYPES.join(',')}
    cursor="pointer"
    height="100%"
    id="homeowner-upload-photo"
    onChange={onUploadPhotoChange}
    onClick={onInputDropOrClick}
    onDragEnter={event => {
      event.preventDefault();
      event.stopPropagation();
      setInvalidUpload(false);
      setIsDragging(true);
    }}
    onDragLeave={() => {
      setIsDragging(false);
    }}
    onDrop={onInputDropOrClick}
    opacity="0"
    position="absolute"
    ref={inputRef}
    title=""
    type="file"
    width="100%"
  />
);

export { UploadInput };
